
import * as Mui from "@material-ui/core";
import { useTheme } from "../../ThemeContext";

const useStyles = Mui.makeStyles({
    root: ({ color }) => ({
        '&.Mui-checked': {
            color: color || '#079455',
        },
        '& .MuiIconButton-label': {
            '& svg': {
                fill: color || '#079455',
            },
        },
    }),
})

export const CheckboxTable = ({ considerDarkMode = true, ...props }) => {

    const { theme } = useTheme()
    const { color, ...rest } = props
    const classes = useStyles({ color })

    return <Mui.Checkbox
        color="primary"
        className={`${considerDarkMode ? (theme === 'dark' ? "checkbox-style-dark" : "checkbox-style-light") : ""} ${color ? classes.root : ""}`}
        {...rest}
    />;
}